import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Table } from 'camino-react'

import setColumns from './Columns'

import LoadingSpinner from 'Components/LoadingSpinner'

const ReportContent = ({
  updateReportState,
  ticketsToApprove,
  showReviewed,
  loading,
  timesheets,
  localStoragePrefix
}) => {
  if (loading) { return <LoadingSpinner /> }

  const columns = setColumns({ updateReportState, ticketsToApprove, showReviewed })
  const data = _.filter(timesheets, (t) => {
    if (showReviewed) { return true }

    return !t.ticket.invoiced
  })

  return (
    <Table {...{
      columns,
      data,
      collapseOnSortingChange: false,
      collapseOnPageChange: false,
      collapseOnDataChange: false,
      pivotBy: ['clientName', 'ticket'],
      localStoragePrefix
    }}
    />
  )
}

ReportContent.propTypes = {
  updateReportState: PropTypes.func.isRequired,
  showReviewed: PropTypes.bool,
  loading: PropTypes.bool,
  timesheets: PropTypes.arrayOf(PropTypes.object),
  localStoragePrefix: PropTypes.string
}

ReportContent.defaultProps = {
  showReviewed: false,
  loading: true,
  timesheets: [],
  localStoragePrefix: ''
}

export default ReportContent
